import { Badge, View } from "@/components/ui";
import type { Icon } from "@/components/shared/icons";
import { Link } from "../../link";
import { Typography } from "@/components/shared/typography";
import { cn } from "@/lib/utils";

export const SideNavbarListItem = ({
  title,
  icon: IconComponent,
  active,
  to,
  external,
  badge,
}: {
  title: string;
  icon: Icon;
  active?: boolean;
  to: string;
  external?: boolean;
  badge?: string;
}) => {
  return (
    <Link
      href={to}
      target={external ? "_blank" : undefined}
      className={cn(
        "flex",
        "items-center",
        "justify-between",
        "rounded-full",
        "ring-1",
        "ring-transparent",
        "p-2",
        "transition-all",
        "hover:ring-primary-border",
        "hover:bg-primary-surface",
        active && "ring-primary-border",
        active && "bg-primary-surface",
      )}
    >
      <View
        className={cn("flex", "flex-1", "flex-row", "items-center", "gap-2")}
      >
        <IconComponent
          className={
            active ? "color-brand-primary" : "color-foreground-default"
          }
          weight={active ? "fill" : "regular"}
          size={20}
        />
        <Typography
          variant="body-sm"
          color={active ? "brand-primary" : "foreground-default"}
        >
          {title}
        </Typography>
      </View>
      {badge && (
        <Badge
          variant="danger-fill"
          outline={false}
          size="sm"
          className={cn("px-1.5", "py-0")}
        >
          {badge}
        </Badge>
      )}
    </Link>
  );
};
